export default __webpack_public_path__ + "static/media/INA.ae688c03.svg";